/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

import facebook from '../images/facebook.svg';
import vimeo from '../images/vimeo.svg';
import instagram from '../images/instagram.svg';
import psn from '../images/psn.svg';

export default class Credits extends React.PureComponent {
  render() {
    return (
      <div className="Credits">
        <div className="Credits__copyright">
          <p>{`© Utopia Films ${(new Date()).getFullYear()}. All rights reserved.`}</p>
          <p>
            <a
              href="https://github.com/glauberm/utopia_films"
              target="_blank"
              rel="noopener noreferrer"
            >
              Code
            </a>
            &nbsp;by&nbsp;
            <a
              href="https://github.com/glauberm"
              target="_blank"
              rel="noopener noreferrer"
            >
              Glauber Mota
            </a>
          </p>
        </div>
        <div className="Credits__social">
          <ul>
            <li>
              <a
                href="https://www.instagram.com/utopiafilmsbrazil/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={facebook}
                  alt="Facebook"
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/utopiafilmsbrazil/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={instagram}
                  alt="Instagram"
                />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/utopiafilmsbrazil/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={vimeo}
                  alt="vimeo"
                />
              </a>
            </li>
          </ul>
        </div>
        <div className="Credits__logo">
          <a
            href="https://www.productionservicenetwork.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={psn}
              alt="Production Service Network"
            />
          </a>
        </div>
      </div>
    );
  }
}
